module.exports = __webpack_public_path__ + "img/blog6-logo-5.87fa95f6.webp";